module.exports = __webpack_public_path__ + "static/img/terminal3.fa39daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminal3.png
// module id = FcQo
// module chunks = 0